import React from 'react';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  MinusCircleFilled,
  SyncOutlined,
} from '@ant-design/icons';
import {
  getEmrStateLabel,
  getEmrStatusSubtext,
  getEmrStatusVisual,
} from '../utils/emrStatusHelpers';

const ICONS = {
  check: CheckCircleFilled,
  close: CloseCircleFilled,
  minus: MinusCircleFilled,
  sync: SyncOutlined,
};

const TONE_COLORS = {
  success: '#52c41a',
  error: '#ff4d4f',
  default: '#8c8c8c',
  processing: '#1677ff',
};

export default function EmrClusterStatus({
  pipeline,
  compact = false,
  isDark = false,
}) {
  const state = pipeline?.status;
  if (!state) {
    return (
      <span style={{ color: isDark ? '#8b949e' : '#999', fontSize: compact ? 11 : 12 }}>
        —
      </span>
    );
  }

  const visual = getEmrStatusVisual(state);
  const Icon = ICONS[visual.icon] || MinusCircleFilled;
  const color = TONE_COLORS[visual.tone] || TONE_COLORS.default;
  const label = getEmrStateLabel(state);
  const subtext = getEmrStatusSubtext(pipeline);

  return (
    <div
      className={`emr-cluster-status${compact ? ' emr-cluster-status--compact' : ''}`}
      style={{ minWidth: 0 }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, minWidth: 0 }}>
        <Icon
          style={{
            color,
            fontSize: compact ? 14 : 16,
            marginTop: compact ? 1 : 2,
            flexShrink: 0,
          }}
          spin={visual.icon === 'sync'}
        />
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: compact ? 12 : 13,
              color: isDark ? '#e6edf3' : '#262626',
              lineHeight: 1.25,
            }}
          >
            {label}
          </div>
          {subtext ? (
            <div
              style={{
                fontSize: compact ? 11 : 12,
                color: isDark ? '#8b949e' : '#8c8c8c',
                lineHeight: 1.3,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: compact ? 2 : 3,
                WebkitBoxOrient: 'vertical',
                wordBreak: 'break-word',
              }}
              title={subtext}
            >
              {subtext}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
